import httpClient, { httpFormDataClient } from "./httpClient";

const prefix = "/department";

export async function fetchDepartments() {
  return (await httpClient.get(`${prefix}`)).data;
}